import { KycCompliance } from '@/types/KycCompliance';
import { CountryData } from '@/types/CountryType';

export function isCompanyBrazilKyc(kyc: KycCompliance) {
  return kyc?.company?.addressCountry?.country === 'BR';
}

export function getCountryCode(
  countries: CountryData[],
  dialCode: string
): string | undefined {
  return countries.find((country) => country.dialCode === dialCode)?.alpha2Code;
}

export function canCompanyRecharge(kyc: KycCompliance) {
  const availableRechargeCountries = ['CO', 'MX', 'EC', 'AR', 'CL', 'PE', 'CR', 'PY'];

  return availableRechargeCountries.includes(
    kyc?.company?.addressCountry?.country
  );
}
